module.exports = __webpack_public_path__ + "9a9babe8b0416ce48a8327b28fa26b84.png";